<template>
  <div class="container--fluid">
    <div class="row">
      <div class="card col-md-12">
        <div class="card-header">
          <h1 class="card-title">SPORTS AI LAB</h1>
          <h4 class="card-subtitle">スポーツのデータ活用・科学に関する論文紹介サイト</h4>
        </div>
      </div>
    </div>
    <div class="row">
      <div v-for="paper in papers" :key="paper.slug" class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
        <v-card
          dark
          color="rgb(29,37,59)"
          class="mx-auto"
        >
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="headline">{{ paper.fields.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-img class="paper-thumbnail"
                 :src="'https://cdn.buttercms.com/'+basename(paper.fields.feature_img)"
          ></v-img>

          <v-card-actions class="text-center">
            <v-btn
              :to="'papers/'+paper.slug"
              class="mx-auto"
              text
              color="deep-purple accent-4"
            >
              Read
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
        <v-card
          dark
          color="rgb(29,37,59)"
          height="100%"
        >
          <v-container fill-height fluid>
            <v-row align="center"
                   justify="center">
              <v-col>
                <v-btn
                  class="mx-auto"
                  text
                  :to="'papers/'"
                  color="deep-purple accent-4"
                >
                  See More
                </v-btn>
              </v-col>
            </v-row>
          </v-container>


        </v-card>
      </div>

    </div>


    <div class="row">
      <div class="col-md-6">

        <card>
          <h4 class="card-title">Youtube</h4>
          <p class="card-text">{{ content.youtube_desc}}</p>
          <youtube
            :video-id="papers[this.papers.length-2].fields.youtube_id"
            player-width="100%"
          ></youtube>

          <div class="text-center">
            <a :href="content.youtube_url" class="btn btn-primary">Videos!</a>
          </div>
        </card>
        <card>
          <h4 class="card-title">Speaker Deck</h4>
          <p class="card-text">{{ content.speakerdeck_desc}}</p>
          <div
            height="100%"
            id="speaker-deck"></div>

          <div class="text-center">
            <a :href="content.speakerdeck_url" class="btn btn-primary">Slides!</a>
          </div>
        </card>
<!--        <card>-->
<!--          <ul slot="raw-content" class="list-group list-group-flush">-->
<!--            <li class="list-group-item">oo justo odio</li>-->
<!--            <li class="list-group-item">Dapibus ac facilisis in</li>-->
<!--            <li class="list-group-item">Vestibulum at eros</li>-->
<!--          </ul>-->
<!--        </card>-->
      </div>
      <div class="col-md-6">
        <card type="nav-tabs">
          <div slot="header" class="card-header-success">
            更新予定
          </div>
          <blockquote class="blockquote mb-0">
            <p>現在，毎週末に更新していく予定です．</p>
            <footer class="blockquote-footer">Last update 2020</footer>
          </blockquote>
        </card>
        <div class="card col-md-12">
          <div class="card-header">
          <h4 class="card-title">Papers covered</h4>
        </div>
          <line-chart class="py-2" style="height: 100%"
                      :chart-data="purpleLineChart.chartData"
                      :gradient-color="purpleLineChart.gradientColors"
                      :gradient-stops="purpleLineChart.gradientStops"
                      :extra-options="purpleLineChart.extraOptions">
          </line-chart>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import card from '@/components/Cards/Card';
  import LineChart from '@/components/Charts/LineChart';
  import Butter from 'buttercms';
  import Dashboard from "./Dashboard";
  import {db} from "../main";

  const butter = Butter('05e3cf8dc2988e25603c8d13cbd9de33a9755dac');

  export default {
    name: "Home",
    components: {
      Dashboard,
      card,
      LineChart,
    },
    methods: {
      basename: function (str) {
        let base = new String(str).substring(str.lastIndexOf('/') + 1);
        if (base.lastIndexOf(".") != -1)
          base = base.substring(0, base.lastIndexOf("."));
        return base;
      }

    },
    created() {
      let me = this
      // Get pages from buttercms
      butter.page.list('papers', {
        'page_size': 3
      }).then(function (response) {
        me.papers = response.data.data
        console.log("Here are your papers")
        console.log(me.papers)
      })

      // Get article data from firebase
      let docRef = db.collection("articles")
      let year_arr = []
      docRef.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          // doc.data() is never undefined for query doc snapshots
          let paper = doc.data()
          console.log(doc.id, " => ", doc.data());
          // year_arr.push(paper.article.year);
        })
      })
      console.log(year_arr)
      me.data.years = year_arr.from(new Set(data)).map(a =>
        ({name: a, y: data.filter(f => f === a).length}))


    },
    mounted() {
      let me = this;
      butter.page.retrieve('*', 'about').then(function (response) {
        me.content = response.data.data.fields
        console.log(me.content)
      })
    },
    updated() {
      if (!this.sd_loaded) {
        let sd = document.createElement('script');

        sd.setAttribute('src', "//speakerdeck.com/assets/embed.js");
        sd.setAttribute('class', "speakerdeck-embed");
        sd.setAttribute('data-slide', "1");
        sd.setAttribute('data-id', this.papers[this.papers.length-2].fields.speakerdeck_id);
        sd.setAttribute('data-ratio', (4 / 3).toString());
        document.getElementById('speaker-deck').appendChild(sd);
        this.sd_loaded = true
      }
    },

    data() {
      return {
        sd_loaded: false,
        content: null,
        years: null,
        papers: null,
        purpleLineChart: {
          extraOptions: {
            maintainAspectRatio: false,
            legend: {
              display: false
            },
            responsive: true,
            tooltips: {
              backgroundColor: '#f5f5f5',
              titleFontColor: '#333',
              bodyFontColor: '#666',
              bodySpacing: 4,
              xPadding: 12,
              mode: "nearest",
              intersect: 0,
              position: "nearest"
            },
            scales: {
              yAxes: [{
                barPercentage: 1.6,
                gridLines: {
                  drawBorder: false,
                  color: 'rgba(29,140,248,0.0)',
                  zeroLineColor: "transparent",
                },
                ticks: {
                  suggestedMin: 50,
                  suggestedMax: 110,
                  padding: 20,
                  fontColor: "#ff8a76"
                }
              }],

              xAxes: [{
                barPercentage: 1.6,
                gridLines: {
                  drawBorder: false,
                  color: 'rgba(220,53,69,0.1)',
                  zeroLineColor: "transparent",
                },
                ticks: {
                  padding: 20,
                  fontColor: "#ff8a76"
                }
              }]
            }


          },
          chartData: {
            labels: ['JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
            datasets: [{
              label: "Data",
              fill: true,
              borderColor: '#d048b6',
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: '#d048b6',
              pointBorderColor: 'rgba(255,255,255,0)',
              pointHoverBackgroundColor: '#d048b6',
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [],
            }]
          }
        }
      }
    }
  }
</script>

<style scoped>
  .paper-thumbnail {
    object-fit: cover;
    height: 150px;
  }
</style>
